import { render } from "./BasicUsage.vue?vue&type=template&id=491ff17c"
import script from "./BasicUsage.vue?vue&type=script&lang=ts"
export * from "./BasicUsage.vue?vue&type=script&lang=ts"

import "./BasicUsage.vue?vue&type=style&index=0&id=491ff17c&lang=css"
script.render = render

export default script